import { GeoLocation } from 'modules/queryBuilder/types';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { FlexWrapper, GeoLocationPrefix, GEO_LOCATION_WIDTH } from './ConditionGeoLocation.styles';
import { LAT_MINIMUM, LON_MINIMUM, LAT_MAXIMUM, LON_MAXIMUM, GEO_LOCATION_STEP } from './constants';
import { ConditionSingleValueGeolocationProps } from '../types';
import { ConditionInputWithoutOptions } from '../ConditionInput/ConditionInputWithoutOptions';

type ConditionGeoLocationInputProps = Omit<
  ConditionSingleValueGeolocationProps,
  'value' | 'onChange'
> & {
  value: GeoLocation | null;
  onChange: (val: GeoLocation) => void;
};

export const ConditionGeoLocationInputs = ({
  value,
  onChange,
  ...props
}: ConditionGeoLocationInputProps) => {
  const { t } = useTranslation();

  return (
    <FlexWrapper>
      <ConditionInputWithoutOptions
        type="number"
        autoFocus={false}
        onChange={(val) => {
          if (!val || !value) return;
          onChange({ lat: val, lon: value.lon });
        }}
        maxValue={LAT_MAXIMUM}
        minValue={LAT_MINIMUM}
        Prefix={<GeoLocationPrefix>{t('storybook.geoLocation.lat')}</GeoLocationPrefix>}
        value={value?.lat ?? null}
        width={GEO_LOCATION_WIDTH}
        step={GEO_LOCATION_STEP}
        {...props}
      />
      <ConditionInputWithoutOptions
        type="number"
        autoFocus={false}
        onChange={(val) => {
          if (!val || !value) return;
          onChange({ lat: value.lat, lon: val });
        }}
        maxValue={LON_MAXIMUM}
        minValue={LON_MINIMUM}
        Prefix={<GeoLocationPrefix>{t('storybook.geoLocation.lon')}</GeoLocationPrefix>}
        value={value?.lon ?? null}
        width={GEO_LOCATION_WIDTH}
        step={GEO_LOCATION_STEP}
        {...props}
      />
    </FlexWrapper>
  );
};
